/*
Please don't use this slice yet. There is an issue with AddressSearch component. Somehow if we use this slice, the component throws 'TypeErrror: "international" is ready-only'
*/

import { createSlice } from '@reduxjs/toolkit';
import { getApplication } from '../../../shared/redux/applicationSlice';
import { clearForm } from './formSlice';

const initialState = {
  firstName: undefined,
  midddleName: undefined,
  lastName: undefined,
  emailAddress: undefined,
  mailingAddress: undefined,
  mobileNumber: undefined,
  address: undefined,
  secondaryContact: undefined,
  employerName: undefined,
  registrationType: undefined,
  amIRegistrationHolder: undefined,
  isEmailAddressValid: true,
  isMobileNumberValid: true,
  isCompleted: false,
  ongoingContact: undefined,
};

const holderDetailsSlice = createSlice({
  name: 'holderDetails',
  initialState,
  reducers: {
    storeHolderDetails(state, action) {
      const holderDetails = action.payload;
      return { ...holderDetails };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(clearForm, () => {
        return initialState;
      })
      .addCase(getApplication.fulfilled, (state, action) => {
        return { ...action.payload.applicationData.holderDetails };
      });
  },
});

export const { storeHolderDetails } = holderDetailsSlice.actions;
export const holderDetailsReducer = holderDetailsSlice.reducer;
